import { Router } from "@angular/router";
import { md, pki } from 'node-forge';

export const DEBOUNCE_TIME = 1000;

export const goToNextPage = (id: any, url: string, router: Router) => {
    if (id.type === 'click'){
        return router.navigate([`${url}`]);
    }
    if(isNaN(id)) {
        return router.navigate([`${url}/${id}`]);
    }
    if(!isNaN(id)) {
        return router.navigate([`${url}/${id}`]);
    }
    return router.navigate([`${url}`]);

}

export const goBack = (url: string, router: Router) =>{
    router.navigate([`${url}`]);
  }

export const remove = (resultArray: any, selectedIndex: any) => {
    return resultArray.map((value: any) => {
      if (!selectedIndex.includes(value.id)){
        return value;
      }
      return null;
    }).filter((group: any) => group);
  }
export const add = (resultArray: any, filteredArray: any) => {
    return filteredArray.filter(
      (group: any) => resultArray.filter((value: any) => value.id === group.id),
    ).flat(Infinity);
  }
export const createUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

/**
 * Returns the appropriate class for VTN health status visualization
 */
export const vtnHealthClass = (vtn: any) => {
  const base = 'glyphicon glyphicon-align-center ';
  const mappings: any = {
    'healthy': base + 'glyphicon-ok-sign text-success',
    'unhealthy': base + 'glyphicon-remove-sign text-danger',
    'unknown': base + 'glyphicon-question-sign text-warning'
  };

  return mappings[vtn.status] || base + 'glyphicon-exclamation-sign text-warning';
};

/**
 * Converts a PEM certificate to a SHA-256 fingerprint
 * @param primary The primary certificate in PEM format
 * @param secondary Optional secondary certificate in PEM format
 * @returns Object with primary and secondary fingerprints
 */
export const convert_sha256 = (primary: string, secondary?: string): { primary: string, secondary: string }  => {
  let primaryFingerprint = "No CA uploaded.";
  let secondaryFingerprint = "No CA uploaded.";

  try {
    // Process primary certificate
    if (primary && typeof primary === 'string' && primary.trim()) {
      try {
        const csrBytes = pki.pemToDer(primary).getBytes();
        const sha256 = md.sha256.create();
        sha256.update(csrBytes, "raw");
        primaryFingerprint = sha256.digest().toHex();
      } catch (error) {
        console.error("Error converting primary certificate:", error);
      }
    }

    // Process secondary certificate if provided
    if (secondary && typeof secondary === 'string' && secondary.trim()) {
      try {
        const csrBytes = pki.pemToDer(secondary).getBytes();
        const sha256 = md.sha256.create();
        sha256.update(csrBytes, "raw");
        secondaryFingerprint = sha256.digest().toHex();
      } catch (error) {
        console.error("Error converting secondary certificate:", error);
      }
    }
  } catch (error) {
    console.error("Error in certificate conversion:", error);
  }

  return {
    primary: primaryFingerprint,
    secondary: secondaryFingerprint,
  };
};

export function extractErrorMessage(error: any, defaultMessage?: string): string {
  // If error has a message property, use it
  const message: string = error?.error?.message || error?.message;
  if (message) {
    if (message.toLowerCase().includes('duplicate key value violates unique constraint')) {
      return 'Duplicate key value. Try again with a different key.'
    }
    if (message.toLowerCase().includes('violates foreign key constraint')) {
      return 'Action not permitted.';
    }
    if (message.toLowerCase().includes('ven is paused')) {
      return 'VEN is paused.';
    }
    return defaultMessage ?? message;
  }

  // If it's a string, return it
  if (typeof error === 'string') {
    return error;
  }

  // Fallback for unexpected error formats
  return defaultMessage ?? 'An unexpected error occurred. Please try again.';
}
